angular.module('tgaApp').controller('MenuController', [
  '$scope',
  '$uibModalInstance',
  'soundService',
  'gameConfig',
  'data',
  'URLParamsService',
  'userService',
  function ($scope, $uibModalInstance, soundService, gameConfig, data, URLParamsService, userService) {
    $scope.data = angular.copy(data);
    $scope.URLParams = URLParamsService.getUserParams();
    $scope.playAgainDisabled = userService.checkSessionLimitReached();

    $scope.actions = {
      click() {
        if (!gameConfig.sfx_muted) {
          soundService.play('click');
        }
      },
      resume() {
        $scope.actions.click();
        if ($scope.menuActions) $scope.menuActions.resume();
        $uibModalInstance.close();
      },
      restartGame() {
        $scope.actions.click();
        $scope.menuActions.restartGame();
        $uibModalInstance.close();
      },
      logout() {
        $scope.actions.click();
        $scope.menuActions.logout();
        $uibModalInstance.close();
      },
      music() {
        $scope.actions.click();
        $scope.data.music = !$scope.data.music;
        $scope.menuActions.toggleMusic();
      },
      sound() {
        $scope.actions.click();
        $scope.data.sound = !$scope.data.sound;
        $scope.menuActions.toggleSound();
      },
      privacy() {
        $scope.actions.click();
        $scope.menuActions.privacy();
      },
      legal() {
        $scope.actions.click();
        $scope.menuActions.legal();
      },
    };
  },
]);
